
import { FlatTransport } from '@/models/FlatTransport'
import { Transport } from '@/models/Transport'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { FileTypes } from '@/components/Messages/AddAttachment.vue'
import i18n from '@/i18n'
import { Document } from '@/models/Document'
import { PluralResponse } from 'coloquent/dist/response/PluralResponse'
import Notification from '@/classes/Notification'
import FileTag from '@/enums/FileTag'

@Component({
	components: {},
	computed: {
		FileTypes() {
			return FileTypes
		}
	}
})
export default class DownloadDocumentDialog extends Vue {
	@Prop({ required: false, default: false })
	opened!: boolean

	@Prop({ required: false, default: () => [] })
	transports!: Array<FlatTransport> | Array<Transport>

	isLoading: boolean = false
	selectedFileTypes: Array<string> = []

	closeDialog() {
		this.$emit('closed')
	}

	get fileTypes() {
		return [
			...FileTypes,
			{
				category: 'transport',
				value: FileTag.BUILDING_MATERIALS_LOADING
			}
		]
			.filter((type) => type.category === 'transport')
			.map((type) => {
				return {
					label: i18n.t(`cargo.attachments.types.${type.value}`) as string,
					...type
				}
			})
			.sort((type, next) => type.label.localeCompare(next.label))
	}

	async downloadDocuments() {
		if (!this.transports.length) return

		let query = Document.query()

		if (this.transports.length) {
			query = (this.transports as Array<FlatTransport>).reduce(
				(q, transport) => q.option('filter[transports][]', transport.getApiId() as string),
				query
			)
		}

		if (this.selectedFileTypes.length) {
			query = this.selectedFileTypes.reduce((q, type) => q.option('filter[tag]', type as string), query)
		}

		try {
			this.isLoading = true
			const returnedDocuments = ((await query.get()) as PluralResponse).getData() as Array<Document>

			await returnedDocuments.reduce(async (prevPromise, document) => {
				await prevPromise
				await document.triggerDownload()
				const fileBlob = document.downloadedFile
				if (!fileBlob) return

				window.open(URL.createObjectURL(fileBlob), '_blank')
			}, Promise.resolve())
		} catch (err) {
			// eslint-disable-next-line
			console.error('Error occurred while downloading the files', err)
			await Notification.Error(i18n.t('errors.download_errors').toString())
		} finally {
			this.isLoading = false
		}

		this.closeDialog()
	}
}
